import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from '../../directives/click-outside.directive';

@Component({
  selector: 'app-dropdown',
  standalone: true,
  imports: [CommonModule, ClickOutsideDirective],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.scss',
})
export class DropdownComponent {
  dropdownOpen: boolean = false;
  value: string = '';
  @Input() label = '';
  @Input() placeholder = '';
  @Input() title = '';
  @Input() items = [];
  @Input() error = '';
  @Output() selectedValue = new EventEmitter<any>();

  open = () => {
    this.dropdownOpen = true;
  };
  close = () => {
    this.dropdownOpen = false;
  };
  setItem = (item: string) => {
    this.value = item;
    if (!this.title) {
      this.selectedValue.emit();
    } else {
      this.selectedValue.emit({ title: this.title, value: item });
    }
    this.close();
  };
}
